module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0131.jpg?v=a912ecc4";